import makeStyles from '@material-ui/styles/makeStyles';

export default makeStyles({
  wrapper: {
    padding: '22px',
    boxShadow: '0 3px 6px 0 rgba(0, 0, 0, 0.16)',
  },
});
